import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

const RedirectToNewContractorPortal = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const intermediaryRegistrationUrl = new URL(process.env.REACT_APP_NEW_INTERMEDIARY_REGISTRATION_URL!);

    searchParams.forEach((value, key) => {
      intermediaryRegistrationUrl.searchParams.set(key, value);
    });

    window.location.replace(intermediaryRegistrationUrl);
  }, [location]);

  return <></>;
};

export default RedirectToNewContractorPortal;
